// (function ($) {
//     if($('.youtube-video-section').length > 0) {
//         var tag = document.createElement('script');

//         tag.src = "https://www.youtube.com/iframe_api";
//         const firstScriptTag = document.getElementsByTagName('script')[0];
//         firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

//         //function onYouTubeIframeAPIReady() {
//             $(window).on('load',function(){
//                 setTimeout(function(){
//                     let index = 1;
//                     $('.youtube-video-section').each(function(){
//                         $(this).find('.elementor-video').after('<div id="my-video-'+ index +'"></div>');
//                         let settings = $(this).find('.elementor-widget-video').data('settings');
//                         console.log(settings.youtube_url)
//                         let id = settings.youtube_url.split('v=')[1];
//                         console.log(id)
//                         let player = new YT.Player('my-video-' + index, { 
//                             playerVars: { 'autoplay': 0 },
//                             videoId: id,                          
//                             events: {
//                                 'onReady': onPlayerReady,
//                             }
//                         });

//                         function onPlayerReady(event) {
//                            event.target.playVideo();
//                         }

//                         $(this).click(function(){
//                             $(this).find('.cover').fadeOut();
//                             $(this).find('.elementor-widget-icon').fadeOut();

//                             player.playVideo();
//                         });
//                         index++;
//                     });
//                 }, 1000)
//             })
//         //}
//     } 
// })(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/youtube-video.js